<script setup lang="ts">
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import { computed, onMounted, ref, watch } from 'vue'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import MoneyCell from '@/onenetwork/components/datatable/MoneyCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import ThumbCell from '@/onenetwork/components/datatable/ThumbCell.vue'
import AttachmentCell from '@/modules/contract/components/parts/AttachmentCell.vue'

interface Props {
  account: object | null,
  currentTab?: string,
}

const props = defineProps<Props>()

const loading = ref<boolean>(false)
const pageSize = ref(10)
const page = ref(0)
const dataSource = ref({
  list: [],
  totalPage: 0,
  totalRecords: 0,
})

const handleChangePage = (page: number) => {

}

const handleChangePageSize = (size: number) => {

}

const requestFetchData = async () => {
  try{
    dataSource.value = {
      list: [
        { id: 1, code: 'ON/MG-2025-01', type: 'Ký gửi độc quyền', name: 'Hợp đồng môi giới độc quyền', attachment: [{type: 'doc', fileName: 'file-sample_1MB.doc', fileUrl: 'https://file-examples.com/wp-content/storage/2017/02/file-sample_1MB.doc', size:1024000}], regdate:  '2025-05-01 00:00:00' },
        ],
      totalPage: 2,
      totalRecords: 16,
    }
  } catch (e) {

  }
}

watch(() => props.currentTab, (newTab) => {
  if (newTab === '6') {
    requestFetchData()
  }
})

onMounted(() => {
  requestFetchData()
})
</script>

<template>
  <data-table
    :loading="loading"
    :tableConfig="{
      canShowHide: false,
      columns: {
        code: { label: 'Mã hợp đồng', component: TextCell, visible: true, class: '', sort: false, config: {} },
        type: { label: 'Loại hợp đồng', component: TextCell, visible: true, class: '', sort: false, config: {} },
        name: { label: 'Tên hợp đồng', component: TextCell, visible: true, class: '', sort: false, config: {} },
        attachment: { label: 'Đính kèm', component: AttachmentCell, visible: true, class: '', sort: false, config: {} },
        regdate: { label: 'Thời gian ký', component: DateTimeCell, visible: true, class: '', sort: false, config: {} },

      }
    }"
    :page-size="pageSize"
    :page="page"
    :total-page="dataSource?.totalPage || 0"
    :total-records="dataSource?.totalRecords || 0"
    :data="dataSource?.list || []"
    @page-changed="handleChangePage"
    @pagesize-changed="handleChangePageSize"

  />
</template>

<style scoped>

</style>
